module.exports = __webpack_public_path__ + "static/hero-projects.12fb44ea.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/hero-projects.jpg
// module id = 299
// module chunks = 0 1